<template>
    <div class="web-integration-container">
        <div class="left-panel-container shadow-sm">
            <div class="web-viewer-config-container">
                <div class="web-viewer-instructions">{{ $t("admin.web_integration.web_viewer.instructions") }}</div>
                <div class="field normal-field web-viewer-format">
                    <label for="web_viewer_format" class="form-label">{{ $t("admin.web_integration.web_viewer.format") }}</label>
                    <select id="web_viewer_format" class="form-control form-select" v-model="webViewerFormat">
                        <option disabled value="">{{ $t("admin.web_integration.web_viewer.format_please_select_one") }}</option>
                        <option value="map">{{ $t("admin.web_integration.web_viewer.format_as_map") }}</option>
                        <option value="list">{{ $t("admin.web_integration.web_viewer.format_as_list") }}</option>
                    </select>
                </div>
                <div class="field normal-field web-viewer-language">
                    <label for="web_viewer_format" class="form-label">{{ $t("admin.web_integration.web_viewer.language") }}</label>
                    <select id="web_viewer_format" class="form-control form-select" v-model="webViewerLanguage">
                        <option disabled value="">{{ $t("admin.web_integration.web_viewer.language_please_select_one") }}</option>
                        <option value="auto_detect">{{ $t("admin.web_integration.web_viewer.language_auto_detect") }}</option>
                        <option value="en">{{ $t("admin.web_integration.web_viewer.language_english") }}</option>
                        <option value="fr">{{ $t("admin.web_integration.web_viewer.language_french") }}</option>
                    </select>
                </div>
                <div class="web-viewer-switches">
                    <div class="field" v-if="webViewerFormat == 'map'">
                        <SwitchControl class="switch" v-model="webViewerSearchAlwaysVisible" />
                        <span>{{ $t("admin.web_integration.web_viewer.search_always_visible") }}</span>
                    </div>
                    <div class="field" v-if="webViewerFormat == 'list'">
                        <SwitchControl class="switch" v-model="webViewerExcludePOIs" />
                        <span>{{ $t("admin.web_integration.web_viewer.exclude_pois") }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-panel-container shadow-sm">
            <div>
                <h5>{{ $t("admin.web_integration.web_viewer.link_to_web_viewer") }}</h5>
                <a class="viewer-link" v-bind:href="this.webViewerUrl" target="_blank">{{ this.webViewerUrl }}</a>
                <a class="copy-link" href="#" v-if="!linkCopied" v-on:click="copyWebViewerLinkToClipboard()">{{ $t("admin.web_integration.web_viewer.copy_link") }}</a>
                <span class="copy-link" v-if="linkCopied">{{ $t("admin.web_integration.web_viewer.link_copied_to_clipboard") }}</span>
            </div>

            <div>
                <h5>{{ $t("admin.web_integration.web_viewer.iframe_integration_example") }}</h5>
                <div class="code">
                    &lt;iframe width=&quot;100%&quot; height=&quot;100%&quot; src=&quot;{{ this.webViewerUrl }}&quot;&gt;&lt;/iframe&gt;
                </div>
            </div>

            <h5>{{ $t("admin.web_integration.web_viewer.result") }}</h5>
            <div class="iframe-container">
                <iframe width="100%" height="100%" v-bind:src="webViewerUrl"></iframe>
            </div>

            <!---->
        </div>
    </div>
</template>

<script>
import SwitchControl from '@/components/ui/control/SwitchControl';
import BrowserUtils from '@/utils/BrowserUtils';

export default {
    components: {
        SwitchControl
    },

    props: {
        publisherId: String,
        mapId: String
    },

    data() {
        return {
            webViewerFormat: "map",
            webViewerLanguage: "auto_detect",
            webViewerSearchAlwaysVisible: false,
            webViewerExcludePOIs: false,
            linkCopied: false
        }
    },

    computed: {
        webViewerUrl() {
            var url = window.location.origin + "/webviewers/" + this.publisherId + "/maps/" + this.mapId;
            if (this.webViewerFormat == 'list') {
                url = url + "?format=list";
                if (this.webViewerExcludePOIs) {
                    url = url + "&excludePOIs=true"
                }
            } else {
                url = url + "?format=map";
                if (this.webViewerSearchAlwaysVisible) {
                    url = url + "&searchAlwaysVisible=true"
                }
            }

            if (this.webViewerLanguage && this.webViewerLanguage != "auto_detect") {
                url = url + "&lang=" + this.webViewerLanguage
            }

            return url;
        }
    },

    methods: {
        copyWebViewerLinkToClipboard() {
            BrowserUtils.copyToClipboard(this.webViewerUrl);
            this.linkCopied = true;
            setTimeout(() => {
                this.linkCopied = false;
            }, 1000);            
        }

    }
}
</script>

<style scoped>
.web-integration-container {
    display: grid;
    column-gap: 8px;
    grid-template-columns: 400px auto;
    justify-items: stretch;
    align-items: stretch;
    width: 100%;
    height: 100%;
}

.field {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.field span {
    display: inline-block;
    margin-left: 8px;
    height: 100%;
}

.normal-field {
    display: block;
    max-width: 500px;
}

.left-panel-container {
    background-color: #ffffff;
    overflow: scroll;
}

.right-panel-container {
    background-color: #ffffff;
    display: flex;
    flex-flow: column;
    height: 100%;
    align-items: stretch;
    padding: 0px 16px 16px 16px;
}

.flex-container {
    background: #ff0000;
}

.web-viewer-config-container {
    padding: 16px;
}

.web-viewer-instructions {
    margin-bottom: 16px;
}

.web-viewer-format {
    padding-bottom: 16px;
}

.web-viewer-language {
    padding-bottom: 16px;
}

.viewer-link {
    font-size: 16px;
}

.code {
    background-color: #efefef;
    border: 1px solid #999999;
    font-family: 'Courier New', Courier, monospace;
    font-size: 12px;
    padding: 16px;
}

.copy-link {
    font-weight: bold;
    margin: 16px;
    text-align: center;
    text-decoration: none;
}

.iframe-container {
    background-color: #dddddd;
    flex: 1 1 auto;
}

h5 {
    padding-top: 16px;
}

iframe {
    border: 1px solid #999999;
}

</style>